@use 'themes/westfield' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;

.form {
  margin-bottom: units(1.5);
  color: #1c1f24;

  label {
    // fix for IE11: labels overflow without this
    width: 100%;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
